"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 17c.327 0 .654-.122.907-.366l7.685-7.367c.855-.821.276-2.267-.907-2.267H4.315c-1.183 0-1.762 1.446-.907 2.267l7.685 7.367c.253.244.58.366.907.366Zm0-1.005a.304.304 0 0 1-.215-.086L4.101 8.54a.294.294 0 0 1-.074-.34.292.292 0 0 1 .288-.195h15.37c.172 0 .252.105.288.195a.29.29 0 0 1-.074.34l-7.684 7.369a.304.304 0 0 1-.215.086Z",
    clipRule: "evenodd"
  })]
});